import { render, staticRenderFns } from "./payconfig-add-or-update.vue?vue&type=template&id=581e3d84&scoped=true"
import script from "./payconfig-add-or-update.vue?vue&type=script&lang=js"
export * from "./payconfig-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./payconfig-add-or-update.vue?vue&type=style&index=0&id=581e3d84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581e3d84",
  null
  
)

export default component.exports